import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import snakeCaseKeys from 'snakecase-keys';

import { sendAlert } from '../../actions/utils';
import { FormHeader } from '../../components';
import { createLeadRequest } from '../../requests/lead';
import LeadForm from '../../components/Lead/LeadForm';
import { basicLead } from '../../components/Lead/basicLead';

const LeadNew = ({ location }) => {
  const modelUrl = '/leads';
  const dispatch = useDispatch();
  const history = useHistory();

  const [accountReference, setAccountReference] = useState('');
  const [isRequested, setIsRequested] = useState(basicLead.requested);
  const [prevFiltersParams, setPrevFiltersParams] = useState(null);

  const handleBreadcrumb = [
    { key: 1, name: 'Ventas', href: modelUrl },
    { key: 2, name: 'Crear nueva oportunidad' }
  ];

  const handleSuccessCreate = response => {
    const { id, requested } = response.data;
    const action = requested ? 'Cotización solicitada' : 'Oportunidad creada';
    dispatch(sendAlert({ kind: 'success', message: `${action} con éxito` }));
    history.push(`${modelUrl}/${id}`);
  };

  const handleCreateRequest = (values, setSubmitting) => {
    const { quotationRequestFile } = values.lead;
    const sendParams = snakeCaseKeys(values);
    sendParams.lead.quotation_request_file = quotationRequestFile;

    createLeadRequest({
      dispatch,
      params: sendParams,
      formData: true,
      successCallback: handleSuccessCreate,
      callback: () => setSubmitting(false)
    });
  };

  const handleSetFiltersOnMount = () => {
    const { state } = location;
    if (!state) return;
    if (state.accountId) setAccountReference(state.accountId);
    else setPrevFiltersParams(state.currentParams);
  };

  useEffect(handleSetFiltersOnMount, []);

  return (
    <div>
      <FormHeader
        handleBreadcrumb={handleBreadcrumb}
        previousFilterParams={prevFiltersParams}
        formComponent={
          <LeadForm
            action="new"
            modelUrl={modelUrl}
            lead={{ ...basicLead, accountId: accountReference }}
            formRequest={handleCreateRequest}
            isRequested={isRequested}
            setIsRequested={setIsRequested}
          />
        }
      />
    </div>
  );
};

export default LeadNew;
